export var DeviceManualUrls;
(function (DeviceManualUrls) {
    // Audio Units
    DeviceManualUrls.AudioBus = "manuals/audio-bus";
    // MIDI Effects
    DeviceManualUrls.Arpeggio = "manuals/devices/midi/arpeggio";
    DeviceManualUrls.Pitch = "manuals/devices/midi/pitch";
    DeviceManualUrls.Spielwerk = "manuals/devices/midi/spielwerk";
    DeviceManualUrls.Velocity = "manuals/devices/midi/velocity";
    DeviceManualUrls.Zeitgeist = "manuals/devices/midi/zeitgeist";
    // Audio Effects
    DeviceManualUrls.Autotune = "manuals/devices/audio/autotune";
    DeviceManualUrls.StereoTool = "manuals/devices/audio/stereotool";
    DeviceManualUrls.Sink = "manuals/devices/audio/sink";
    DeviceManualUrls.Delay = "manuals/devices/audio/delay";
    DeviceManualUrls.Convolver = "manuals/devices/audio/convolver";
    DeviceManualUrls.DattorroReverb = "manuals/devices/audio/dattorro-reverb";
    DeviceManualUrls.Maximizer = "manuals/devices/audio/maximizer";
    DeviceManualUrls.Compressor = "manuals/devices/audio/compressor";
    DeviceManualUrls.Gate = "manuals/devices/audio/gate";
    DeviceManualUrls.Reverb = "manuals/devices/audio/reverb";
    DeviceManualUrls.Crusher = "manuals/devices/audio/crusher";
    DeviceManualUrls.Fold = "manuals/devices/audio/fold";
    DeviceManualUrls.Tidal = "manuals/devices/audio/tidal";
    DeviceManualUrls.Revamp = "manuals/devices/audio/revamp";
    DeviceManualUrls.Modular = "manuals/devices/audio/modular";
    DeviceManualUrls.NeuralAmp = "manuals/devices/audio/neural-amp";
    DeviceManualUrls.Wclap = "manuals/devices/audio/wclap";
    DeviceManualUrls.Vocoder = "manuals/devices/audio/vocoder";
    DeviceManualUrls.Waveshaper = "manuals/devices/audio/waveshaper";
    DeviceManualUrls.Werkstatt = "manuals/devices/audio/werkstatt";
    DeviceManualUrls.AudioEffectComposite = "manuals/devices/audio/effect-composite";
    DeviceManualUrls.StereoComposite = "manuals/devices/audio/stereo-composite";
    // Instruments
    DeviceManualUrls.Apparat = "manuals/devices/instruments/apparat";
    DeviceManualUrls.Tape = "manuals/devices/instruments/tape";
    DeviceManualUrls.Nano = "manuals/devices/instruments/nano";
    DeviceManualUrls.Playfield = "manuals/devices/instruments/playfield";
    DeviceManualUrls.InstrumentComposite = "manuals/devices/instruments/composite";
    DeviceManualUrls.Vaporisateur = "manuals/devices/instruments/vaporisateur";
    DeviceManualUrls.Neon = "manuals/devices/instruments/neon";
    DeviceManualUrls.Tubular = "manuals/devices/instruments/tubular";
    DeviceManualUrls.MIDIOutput = "manuals/devices/instruments/midioutput";
    DeviceManualUrls.Soundfont = "manuals/devices/instruments/soundfont";
    DeviceManualUrls.FrequencySplit = "manuals/devices/audio/frequency-split";
})(DeviceManualUrls || (DeviceManualUrls = {}));
